/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconOverview = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <g
        fill={fill}
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M10.5 12.526a.978.978 0 0 1-.975.98h-7.8a.976.976 0 0 1-.975-.979V1.736a.978.978 0 0 1 .976-.98s0 0 0 0l7.8.013a.978.978 0 0 1 .974.98v10.777zM23.246 6.544a.969.969 0 0 1-.975.962h-7.8a.968.968 0 0 1-.975-.961V1.731a.968.968 0 0 1 .973-.962l7.8-.013a.97.97 0 0 1 .977.962v4.826zM10.5 22.291a.971.971 0 0 1-.977.965s0 0 0 0l-7.8-.013a.969.969 0 0 1-.973-.964V17.47a.97.97 0 0 1 .974-.964h7.801a.97.97 0 0 1 .975.964v4.821zM14.472 23.256a.978.978 0 0 1-.976-.98V11.487a.978.978 0 0 1 .975-.981s0 0 0 0h7.8c.54.002.977.441.975.981 0 0 0 0 0 0v10.775a.979.979 0 0 1-.974.981l-7.8.013z" />
      </g>
    </svg>
  ),
);
